import reducer from "./reducer";
export { default as Feedback } from "./components/index";
export { default as feedbackReducerName } from "./constants";
export default reducer;
